<template>
  <el-container direction="vertical">
    <!-- 查询条件 -->
    <el-row style="height: 40px; line-height: 35px; border-radius: 4px; border: 1px solid #ccc; margin: 10px;" :gutter="10">
      <el-col :span="3">
        <el-input v-model="search.minScore" placeholder="请输入最低分" clearable @keyup.enter.native="query"></el-input>
      </el-col>

      <el-col :span="1" style="text-align:center;width: 40px;">-</el-col>

      <el-col :span="3">
        <el-input v-model="search.maxScore" placeholder="请输入最高分" clearable @keyup.enter.native="query"></el-input>
      </el-col>
      
       <el-col :span="3">
         <el-select v-model="search.province" placeholder="请选择省份" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="请选择"></el-option>
          <el-option v-for="(item, index) in globalData.provinceOptions" :key="index" :value="item.value" :label="item.text"></el-option>
        </el-select>
      </el-col> 

      <el-col :span="3">
        <el-select v-model="search.type" placeholder="请选择作品类别" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option value="科普" label="科普"></el-option>
          <el-option value="科幻" label="科幻"></el-option>
        </el-select>
      </el-col> 
      <el-col :span="3">
        <el-select v-model="search.mark" placeholder="请选择标记类别" style="width: 100%" clearable @keyup.enter.native="query">
          <el-option value="" label="全部"></el-option>
          <el-option value="excellent" label="优秀作品"></el-option>
          <el-option value="low" label="典型错误"></el-option>
        </el-select>
      </el-col> 
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="query">查询</el-button>
      </el-col>
    </el-row>

    <!-- 数据展示 -->
    <el-row style="flex: 1; background: #ccc; margin: 0 10px;display:flex">
      <el-table :data="page.list" height="100%"  border style="width: 100%;" v-loading="loading">
        <el-table-column type="index" :index="indexMethod" width="50"></el-table-column>
        <el-table-column prop="province" label="省份" min-width="130"></el-table-column>
        <el-table-column prop="title" label="作品标题" min-width="200"></el-table-column>
        <el-table-column prop="type" label="作品类别" min-width="200"></el-table-column>
        <el-table-column prop="score" label="得分" min-width="200"></el-table-column>
        <el-table-column prop="judgeTime" label="评审时间" min-width="200"></el-table-column>
        <el-table-column label="作品标记" min-width="200">
          <template slot-scope="sp">
            <span v-if="sp.row.excellent">优秀作品</span>
            <span v-if="sp.row.low">典型错误</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewWork(scope.row)" >预览</el-button>
            <el-button type="text" size="small" @click="modifyScore(scope.row)">修改得分</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    
    <!-- 分页 -->
    <el-row style="border: 1px solid #aaa; box-sizing: border-box; background: #e1e1e1; margin: 0 10px 10px 10px; text-align: center;">
      <el-pagination background layout="prev, pager, next,total" :current-page="pageNum" :page-size="20" :total="page.total" @current-change="pageChange"></el-pagination>
    </el-row>

  </el-container>  
</template>

<script>
export default {
  computed: {

  },
  data() {
    return {
      page: {},
      pageNum: 1,
      tableHeight: '300px',
      search: {
        judgeId: JSON.parse(sessionStorage.getItem("manager")).id,
        pageNum: 1
      },
      loading:true
    }
  },
  methods: {

    // 分页显示数据
    pageChange(n) {
      this.pageNum = n
      this.loadData()
    },

    // 作品预览
    viewWork(row) {
      this.globalData.work = row
      this.$dialog.workViewer()
    },

    // 行号
    indexMethod(index){
      return (this.pageNum - 1) * 20 + index + 1
    },

    // 修改得分
    modifyScore(row){
      this.$prompt('请输入得分', `作品标题：${row.title}`, {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          row.score = parseInt(value)
          this.api.works.saveWork(row).then(() => {
            this.$notify({
              title: '提示',
              message: '得分修改成功',
              type: 'success'
            });
          })
        }).catch(() => {})
    },

    // 数据查询
    query() {
      this.pageNum = 1
      this.loadData()
    },

    // 加载数据
    loadData() {
      this.search.pageNum = this.pageNum
      this.api.works.findMongoPage(this.search).then(res => {
        this.page = res.data
        this.loading = false
      })
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

